import { AngebotsId } from '@ps20-frontend/shop-integration-redux';
import { ElementPreV2, StatePreV2, StateV2 } from './2_migrate_treuebonus_rbd.interface';

export const migrateRbdTreuebonus = (previousState: StatePreV2, newVersion: number): StateV2 => {
  const migratedRBD = previousState.rbd.map(rbd => {
    return migrateElement(rbd);
  });
  const migratedTreuebonus = previousState.treuebonus.map(treubonus => {
    return migrateElement(treubonus);
  });
  return {
    ...previousState,
    version: newVersion,
    treuebonus: migratedTreuebonus,
    rbd: migratedRBD,
  };
};

function migrateElement(element: ElementPreV2): AngebotsId {
  const newElement = {
    ...element,
    appId: element.id,
  };
  delete newElement.id;
  return newElement;
}
